import { FINISH_TXNS_SHOW_MORE } from './txns'
import { INFLATE as INFLATE_USER_TXNS } from './user_txns'

export default function reducer(state = { map: {} }, action) {
  switch (action.type) {
    case FINISH_TXNS_SHOW_MORE: {
      const photosMappedToIds =
        action.payload.response && action.payload.response.photos
      return {
        ...state,
        map: { ...mergePhotosIntoContributers(state.map, photosMappedToIds) },
      }
    }
    case INFLATE_USER_TXNS: {
      const newContributors = action.payload.list.reduce((map, txn) => {
        if (txn.contributor_id) {
          map[txn.contributor_id] = {
            full_name: txn.contributor_name,
            photo: txn.contributor_photo,
          }
        }
        return map
      }, {})
      return { ...state, map: { ...newContributors, ...state.map } }
    }
    default:
      return state
  }
}

function mergePhotosIntoContributers(contributors, photosMappedToIds = {}) {
  return Object.keys(contributors).reduce((newContributors, id) => {
    const contributor = contributors[id]
    newContributors[id] = {
      ...contributor,
      photo: contributor.photo || photosMappedToIds[id],
    }
    return newContributors
  }, {})
}
